/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
import { Locale } from '@eon-home/react-library';

export const enum Language {
    ENGLISH = 'English',
    GERMAN = 'Deutsch',
    ITALIAN = 'Italiano',
    ROMANIAN = 'Română',
    HUNGARIAN = 'Magyar',
}

export enum ISO_RegionToRegion {
    'de_DE' = 'DE',
    'en_GB' = 'GB',
    'it_IT' = 'IT',
    'hu_HU' = 'HU',
}

export enum UppercaseLocaleToRegion {
    DE = 'DE',
    EN = 'GB',
    IT = 'IT',
    HU = 'HU',
}

const enum CmsExtraLocale {
    EN = 'en',
}

export type ExtendedLocale = Locale & CmsExtraLocale;

export enum CIAM_COUNTRIES {
    // Taken from the backend implementation
    'United Kingdom' = 'en_GB',
    'Germany' = 'de_DE',
    'Italy' = 'it_IT',
    'Netherlands' = 'nl_NL',
    'Czech Republic' = 'cz_CZ',
    'en_GB' = 'en_GB',
    'de_DE' = 'de_DE',
    'it_IT' = 'it_IT',
    'sv_SE' = 'sv_SE',
    'nl_NL' = 'nl_NL',
    'hu_HU' = 'hu_HU',
    'cz_CZ' = 'cz_CZ',
    'GB' = 'en_GB',
    'DE' = 'de_DE',
    'IT' = 'it_IT',
    'HU' = 'hu_HU',
    'CZ' = 'cz_CZ',
    // Added by the frontend
    'EN' = 'en_GB',
}
